export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "index.worker.a538c9a337f96486ebba.worker.js");
}
